import { isFixedProduct } from '@vy/services';
import { type FixedProduct, type UsageProduct } from '@vy/types';
import { values } from '@vy/utils';
import { CLOUD_PROVIDER, type CloudProvider } from '@vy/connact';
import { VyStack } from '@vy/ui-design-system';
import { useEffect } from 'react';
import { withSuspenseBoundary } from '../../../../../../components/utility/SuspenseBoundary';
import { useFormErrorNotificationContext } from '../../../../../../contexts/form-error-notification-context/form-error-notification-context';
import { useChargeContext } from '../../charge-context';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from '../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { CREATE_PLAN_TABS } from '../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { VySelectField, VyTextFieldField } from '../../../../../../design-system-adapters/forms';

const marketplaceOptions = values(CLOUD_PROVIDER);

const ProductMarketplaceSelectorInner: React.FC = () => {
  const { itemIndex: productIndex, item: product } = useChargeContext<FixedProduct | UsageProduct>();
  const { registerErrorField } = useFormErrorNotificationContext<PlanInputForm, CreatePlanTab>();

  const productType = isFixedProduct(product) ? 'fixedProducts' : 'usageProducts';
  const cloudProviderSettingsField = `${productType}.${productIndex}.cloudProviderSettings` as const;

  useEffect(() => {
    registerErrorField(cloudProviderSettingsField, CREATE_PLAN_TABS.serviceFees);
  }, [registerErrorField, cloudProviderSettingsField]);

  return (
    <VyStack spacing={2.5}>
      <VySelectField<PlanInputForm, CloudProvider>
        name={`${productType}.${productIndex}.cloudProviderSettings.cloudProvider`}
        label="Marketplace"
        placeholder="Select Marketplace"
        options={marketplaceOptions}
        getOptionLabel={(option) => option}
        data-vy="plan-charge-drawer-marketplace-provider"
      />
      <VyTextFieldField<PlanInputForm>
        name={`${productType}.${productIndex}.cloudProviderSettings.cloudProviderMarketplaceId`}
        label="Product Marketplace ID"
        placeholder="Enter Product Marketplace ID"
        data-vy="plan-charge-drawer-marketplace-id"
      />
      <VyTextFieldField<PlanInputForm>
        name={`${productType}.${productIndex}.cloudProviderSettings.dimension`}
        label="Dimension"
        placeholder="Enter Dimension"
        data-vy="plan-charge-drawer-marketplace-dimension"
      />
    </VyStack>
  );
};

const ProductMarketplaceSelectorWithSuspenseBoundary = withSuspenseBoundary(ProductMarketplaceSelectorInner);

export { ProductMarketplaceSelectorWithSuspenseBoundary as ProductMarketplaceSelector };
